import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import isEmpty from 'lodash-es/isEmpty'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { RENTAL_PORTAL_VIEWING_STATUSES } from '../../../../constants/rentalPortal'
import { EntityStatus } from '../../../Entity'
import { ButtonSelect } from '../../../Select'
import { QA_NAME_VIEWING_PROFILE_STATUS_SELECT } from '../RentalPortalViewingProfile.constants'
import {
  useViewingProfileContext,
  useViewingStatusChange,
} from '../RentalPortalViewingProfile.hooks'
import {
  getCanEditViewingStatus,
  getViewingStatusSelectOptions,
  getViewingStatusSelectValue,
} from '../RentalPortalViewingProfile.utils'

import { RentalPortalViewingProfileHeaderStatusSelectButton } from './RentalPortalViewingProfileHeaderStatusSelectButton'

import * as styles from './RentalPortalViewingProfileHeaderStatusSelect.module.css'

function RentalPortalViewingProfileHeaderStatusSelect({
  className,
  height,
  isLoading,
  textClassName,
}) {
  const { t } = useTranslation()

  const { viewingData } = useViewingProfileContext()

  const { handleOpenStatusConfirmation, isStatusUpdating } =
    useViewingStatusChange()

  const options = getViewingStatusSelectOptions({ t, viewingData })

  const canEditStatus = getCanEditViewingStatus(viewingData)

  function handleSelectItem(option) {
    handleOpenStatusConfirmation(option.value)
  }

  return isEmpty(options) ? (
    <EntityStatus
      className={classNames(className, styles.badge)}
      height={height}
      id={viewingData?.status}
      statuses={RENTAL_PORTAL_VIEWING_STATUSES}
      textClassName={textClassName}
    />
  ) : (
    <ButtonSelect
      Control={RentalPortalViewingProfileHeaderStatusSelectButton}
      className={className}
      controlProps={{ isSkeleton: isLoading }}
      disabled={!canEditStatus || isLoading || isStatusUpdating}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottom,
        maxWidthByRef: false,
      }}
      dropdownProps={{ className: styles.dropdown }}
      listProps={{ headerProps: { Search: null } }}
      options={options}
      qaName={QA_NAME_VIEWING_PROFILE_STATUS_SELECT}
      tooltip={
        canEditStatus
          ? null
          : t('RentalPortal.ViewingStatusChangeNotAllowedTooltipKey')
      }
      value={getViewingStatusSelectValue({ status: viewingData?.status, t })}
      onSelectItem={handleSelectItem}
    />
  )
}

export default RentalPortalViewingProfileHeaderStatusSelect
